import { render, staticRenderFns } from "./DataXueZhi.vue?vue&type=template&id=32c53dff&"
import script from "./DataXueZhi.vue?vue&type=script&lang=js&"
export * from "./DataXueZhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports